module.exports = __webpack_public_path__ + "img/product_51.f1e5fc0.webp";